import React, { useRef, lazy } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenIcon, ShieldCheckIcon } from 'lucide-react';
const bonuses = [{
  title: '7 Días para Frenar la Crisis',
  promise: 'El mapa de ruta paso a paso para detener la caída libre hoy mismo.',
  description: <>
        Un protocolo de intervención rápida con{' '}
        <strong data-id="element-74" data-mp="1yc6zo0j1i5pf">acciones diarias atómicas</strong> para bajar la tensión y
        establecer un <em data-id="element-75" data-mp="1amct20pbdddm">"Cese al Fuego" inmediato</em>. Sin teorías largas,
        solo resultados.
      </>,
  value: '7.999',
  image: 'https://cdn.magicpatterns.com/uploads/djExZAHQXwT1ARvWnMhxrn/7_dias_para_frenar_la_crisis.png'
}, {
  title: 'Botiquín de Emergencia',
  promise: 'Qué decir y qué hacer cuando una discusión se sale de control.',
  description: <>
        La guía táctica para <strong data-id="element-76" data-mp="myuv1nfghj27">desescalar peleas en segundos</strong>.
        Incluye las 5 frases de <em data-id="element-77" data-mp="mws7da1s020n">"freno de emergencia"</em> para evitar decir
        cosas de las que te podrías arrepentir.
      </>,
  value: '7.999',
  image: 'https://cdn.magicpatterns.com/uploads/jkLGVRcS3N8SscX5qGX8s3/Botiquin_de_emergencia.png'
}, {
  title: 'Manual Táctico de Pareja',
  promise: 'Las reglas del juego para una convivencia en paz.',
  description: <>
        Cómo transformar los reproches en <strong data-id="element-78" data-mp="1qt8ow8wqmuwl">pedidos claros</strong>. Este
        manual te enseña a <em data-id="element-79" data-mp="1qv1vjo7cpf4l">negociar acuerdos</em> sin que nadie sienta que
        "perdió" la batalla.
      </>,
  value: '7.999',
  image: 'https://cdn.magicpatterns.com/uploads/wKApqVvyBCDqCH2Cncyjz3/Manual_tactico_de_pareja.png'
}, {
  title: 'Re-Conexión',
  promise: 'Volver a sentirse cerca, aunque hoy se sientan como extraños.',
  description: <>
        Ejercicios guiados de vulnerabilidad y{' '}
        <strong data-id="element-80" data-mp="3h5mxdbmx5zrg">micro-citas diseñadas</strong> para reconstruir la{' '}
        <em data-id="element-81" data-mp="3h3tqbv8e9dix">intimidad emocional y física</em> de forma segura y sin presiones.
      </>,
  value: '7.999',
  image: 'https://cdn.magicpatterns.com/uploads/iW56oLf71hUnkM7gDbQkCd/Re-Conexion.png'
}, {
  title: 'Sinceridad Radical',
  promise: 'Limpiar los resentimientos acumulados para empezar de cero.',
  description: <>
        Un cuaderno de trabajo terapéutico para{' '}
        <strong data-id="element-82" data-mp="1m0ds9vl3kty1">cerrar heridas viejas</strong>. Aprende a{' '}
        <em data-id="element-83" data-mp="ydyw2la3omhb">perdonar de verdad</em> y a soltar las deudas emocionales que
        bloquean el futuro.
      </>,
  value: '7.999',
  image: 'https://cdn.magicpatterns.com/uploads/k7Qc1xACXsTdVbfQpR5WVs/Sinceridad_Radical.png'
}];
export function BonusSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full pt-32 pb-24 md:pt-40 md:pb-32 bg-[#0D002B]" data-id="element-84" data-mp="envas9n4ti2n">
      <div className="max-w-6xl mx-auto px-6" data-id="element-85" data-mp="am9yapeif5sz">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-24 md:mb-32" data-id="element-86" data-mp="alidm9mgashh">
          <div className="inline-block bg-[#E5A83B]/20 text-[#E5A83B] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-87" data-mp="j7t6qgp1qzrj">
            OFERTA IRRESISTIBLE
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 font-serif" data-id="element-88" data-mp="9b6l3powc4og">
            El sistema completo para reconstruir una relación en crisis
          </h2>
          <p className="text-lg md:text-xl text-[#C4B5FD] font-sans max-w-2xl mx-auto mb-10" data-id="element-89" data-mp="2u15s9wy4a9q0">
            Además del protocolo principal, te llevás la{' '}
            <strong data-id="element-90" data-mp="3f86idbctfzm6">colección completa</strong> de herramientas tácticas.
          </p>
          <h3 className="text-2xl md:text-3xl font-bold text-white font-sans" data-id="element-91" data-mp="3f9zqkv32urwa">
            Comprando hoy te llevas de regalo{' '}
            <span className="text-[#E5A83B]" data-id="element-92" data-mp="35htupa9pfqbt">5 BONUS</span>
          </h3>

          <div className="mt-10" data-id="element-93" data-mp="30jabhhmhwsn5">
            <img src="https://cdn.magicpatterns.com/uploads/1RTY5b2nJEd6nYQuabZoTt/Producto_principal_y_bonus.png" alt="5 Bonus - Colección completa de ebooks" className="w-full max-w-[600px] mx-auto h-auto rounded-2xl" style={{
            filter: 'drop-shadow(0 25px 50px rgba(124, 58, 237, 0.25))'
          }} data-id="element-94" data-mp="30k1xc0qajc08" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.55,
        delay: 0.15
      }} className="mb-12 grid gap-4 rounded-2xl border border-[#E5A83B]/35 bg-[#110038] p-6 text-center sm:grid-cols-3 sm:text-left" data-id="element-95" data-mp="3j98kq1214rsd">
          <div className="sm:border-r sm:border-[#7C3AED]/30 sm:pr-5" data-id="element-96" data-mp="121q9sipbnweb">
            <p className="text-xs font-bold uppercase tracking-wider text-[#E5A83B]" data-id="element-97" data-mp="170ticd4igkr1">
              Incluye hoy
            </p>
            <p className="mt-1 font-serif text-xl font-bold text-white" data-id="element-98" data-mp="1b1dbz6pvl68f">
              Protocolo + 5 bonus
            </p>
          </div>
          <div className="sm:border-r sm:border-[#7C3AED]/30 sm:px-5" data-id="element-99" data-mp="1g216w3h8677x">
            <p className="text-xs font-bold uppercase tracking-wider text-[#E5A83B]" data-id="element-100" data-mp="1kyzwq9tuvs0b">
              Valor de los bonus
            </p>
            <p className="mt-1 font-serif text-xl font-bold text-white" data-id="element-101" data-mp="3hupd8lp61arx">
              <span className="line-through text-[#A78BFA]" data-id="element-102" data-mp="3ms7le9vczlyv">$39.995</span>{' '}
              <span className="text-[#E5A83B]" data-id="element-103" data-mp="3es1aytqjec5x">incluidos</span>
            </p>
          </div>
          <div className="sm:pl-5" data-id="element-104" data-mp="3aq6cry3wkewd">
            <p className="text-xs font-bold uppercase tracking-wider text-[#E5A83B]" data-id="element-105" data-mp="3ar7kptpmgl9v">
              Acceso
            </p>
            <p className="mt-1 font-serif text-xl font-bold text-white" data-id="element-106" data-mp="3omtai33oj93c">
              Inmediato y de por vida
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-107" data-mp="1iwv0ytq3m6z">
          {/* First row: 3 cards */}
          {bonuses.slice(0, 3).map((bonus, index) => <BonusCard key={index} bonus={bonus} index={index} isInView={isInView} data-id="element-108" data-mp="basvggja7oed" data-mpi={index} />)}

          {/* Second row: 2 cards centered */}
          <div className="md:col-span-3 flex flex-col md:flex-row justify-center gap-8" data-id="element-109" data-mp="l7nud0jgvqt6">
            {bonuses.slice(3, 5).map((bonus, index) => <div key={index + 3} className="w-full md:w-[calc(33.333%-1rem)]" data-id="element-110" data-mp="g79kdcyb26si" data-mpi={index}>
                <BonusCard bonus={bonus} index={index + 3} isInView={isInView} data-id="element-111" data-mp="zvnwgyvfh5p3" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}
function BonusCard({
  bonus,
  index,
  isInView
}: {
  bonus: any;
  index: number;
  isInView: boolean;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 30
  }} transition={{
    duration: 0.6,
    delay: index * 0.15,
    ease: 'easeOut'
  }} className="bg-[#E0D7FF] rounded-[20px] border border-white shadow-[0_10px_40px_-15px_rgba(124,58,237,0.15)] flex flex-col h-full relative overflow-hidden" data-id="element-112" data-mp="g6wvksq1ct0s">
      <div className="absolute top-3 right-3 bg-[#7C3AED] text-white text-xs font-bold px-3 py-1 rounded-full z-20 shadow-md" data-id="element-113" data-mp="26m3jmczp8e1">
        BONUS #{index + 1}
      </div>

      {/* Cover image — full quality, no cropping */}
      {bonus.image && <div className="w-full bg-gradient-to-br from-[#7C3AED]/10 to-[#E5A83B]/10 pt-8 pb-6 px-6 flex justify-center" data-id="element-114" data-mp="8o7eki1ishac">
          <img src={bonus.image} alt={bonus.title} className="w-auto h-48 md:h-56 object-contain drop-shadow-[0_15px_25px_rgba(30,10,60,0.35)]" loading="lazy" data-id="element-115" data-mp="3okrzhzsxoov" />
        </div>}

      <div className="p-6 md:p-8 flex flex-col flex-1" data-id="element-116" data-mp="3q344ta94ovt8">
        <div className="w-10 h-10 bg-[#7C3AED]/10 rounded-lg flex items-center justify-center mb-4" data-id="element-117" data-mp="3m4ok5d0irziz">
          <BookOpenIcon className="w-5 h-5 text-[#7C3AED]" data-id="element-118" data-mp="3h5leprgmnrah" />
        </div>

        <h3 className="text-xl font-bold text-[#1E0A3C] mb-3 font-serif leading-snug" data-id="element-119" data-mp="3c5z29k8mif2q">
          {bonus.title}
        </h3>

        <p className="text-[#7C3AED] font-semibold italic mb-4 text-sm font-sans" data-id="element-120" data-mp="377e3zqcxm5gx">
          {bonus.promise}
        </p>

        <p className="text-[#3B1F6E] leading-relaxed font-sans text-sm mb-6 flex-1" data-id="element-121" data-mp="2x262advnq501">
          {bonus.description}
        </p>

        <div className="mt-auto pt-5 border-t border-[#7C3AED]/20" data-id="element-122" data-mp="370lu6j2idial">
          <div className="flex items-center justify-between" data-id="element-123" data-mp="371ddovitzpki">
            <div className="flex flex-col gap-1" data-id="element-124" data-mp="3bzyhf4xakrdp">
              <span className="text-xs text-[#6B5B8D] line-through font-medium" data-id="element-125" data-mp="3bxlxim7z46y0">
                Valor Real: ${bonus.value}
              </span>
              <span className="text-sm font-bold text-[#34D399] bg-black px-3 py-1 rounded-md inline-block w-max" data-id="element-126" data-mp="2ja806n0d59dd">
                HOY: GRATIS
              </span>
            </div>
            <ShieldCheckIcon className="w-7 h-7 text-[#7C3AED]/40" data-id="element-127" data-mp="2t0kis9omasgv" />
          </div>
        </div>
      </div>
    </motion.div>;
}